import React, { useState } from 'react';
import ImagePlay from 'presentation/assets/images/play-button.png';
import Pagination from 'presentation/components/organisms/Pagination';

function Items({ currentItems }) {
  return (
    <div className='list-container'>
      {currentItems &&
        currentItems.map((records) => (
          <a
            key={records.uuid}
            href={records.share_url}
            target='_blank'
            rel='noreferrer'
            className='list-items flex flex-col sm:flex-row items-center justify-between max-w-2xl mx-auto border-2 border-gray-500 hover:border-green-500 rounded-md my-1 px-5 py-5'
          >
            <div className='flex flex-row items-center space-x-5'>
              <img
                src={ImagePlay}
                alt='default img'
                className='h-12 w-12 rounded-full'
              />
              <div>
                <h1 className='tracking-tight dark:text-gray-100'>
                  {records.start_time}
                </h1>
                <p className='text-gray-600 font-light dark:text-gray-300'>
                  {records.topic}
                </p>
              </div>
            </div>
            <div>
              <p className='text-sm font-semibold leading-none text-right text-gray-800 mb-2'>
                {records.duration} Mínutos
              </p>
              <div className='bg-green-700 rounded-md px-4 py-1 text-white-500 text-sm font-semibold mt-4 sm:mt-0'>
                Ver
              </div>
            </div>
          </a>
        ))}
    </div>
  );
}

function PaginatedItems({ items }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;
  const currentItems = items.slice(indexOfFirstPost, indexOfLastPost);
  const paginateFront = () => setCurrentPage(currentPage + 1);
  const paginateBack = () => setCurrentPage(currentPage - 1);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Items currentItems={currentItems} />
      <div className='pagination'>
        <Pagination
          postsPerPage={itemsPerPage}
          totalItems={items.length}
          paginateBack={paginateBack}
          paginateFront={paginateFront}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
    </>
  );
}

export default PaginatedItems;
